import { forwardRef } from "react";
import { TIMELINE_HEADER_HEIGHT } from "../core/layoutConstants";
import classNames from "classnames";

interface SBDScrollContainerProps {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly style?: React.CSSProperties;
  readonly onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
}

function SBDScrollContainerWithRef(props: SBDScrollContainerProps, ref: React.Ref<HTMLDivElement>) {
  const { children, className, style, onScroll } = props;

  return (
    <div
      className={classNames(
        "order-2 w-full overflow-auto",
        "[&::-webkit-scrollbar]:h-[9px] [&::-webkit-scrollbar]:w-[9px]",
        "[&::-webkit-scrollbar-track]:bg-background-color-emphasis-secondary",
        "[&::-webkit-scrollbar-thumb]:bg-background-color-accent-gray",
        "[&::-webkit-scrollbar-thumb:hover]:bg-background-color-accent-gray",
        "[&::-webkit-scrollbar-thumb]:rounded-[9px]",
        className ?? "",
      )}
      style={{ height: `calc(100% - ${TIMELINE_HEADER_HEIGHT}px)`, ...style }}
      ref={ref}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
}

export const SBDScrollContainer = forwardRef<HTMLDivElement, SBDScrollContainerProps>(
  SBDScrollContainerWithRef,
);
